// frontend/src/utils/entradasCobertura.ts
// Cálculo de cobertura de un déficit ("falta") de un componente con sus próximas
// entradas de compra/recepción. Acumula las entradas futuras por fecha hasta cubrir
// la falta y devuelve la fecha estimada en que quedaría cubierta.
//
// Aproximación de negocio: suma las entradas de ESTE componente frente a su propia
// `falta`, sin descontar el consumo de otras OT que compartan el mismo artículo.
import type { EntradaCompraRow } from '@/types';

export interface CoberturaEntradas {
  futuras: EntradaCompraRow[];   // tipo !== 'disponibilidad', ordenadas por fechaEntrada asc
  totalEntrante: number;         // suma de qtyEntrada de `futuras`
  coveredDate: string | null;    // fecha (ISO) de la 1ª entrada que hace el acumulado >= falta
  coveredIndex: number | null;   // índice en `futuras` de esa entrada (para resaltarla)
}

export function coberturaEntradas(entradas: EntradaCompraRow[], falta: number): CoberturaEntradas {
  // Solo entradas futuras reales; excluye las filas de stock actual ('disponibilidad').
  const futuras = entradas
    .filter(e => e.tipo !== 'disponibilidad')
    .sort((a, b) => (a.fechaEntrada ?? '￿').localeCompare(b.fechaEntrada ?? '￿'));

  const totalEntrante = futuras.reduce((s, e) => s + (e.qtyEntrada ?? 0), 0);

  let coveredDate: string | null = null;
  let coveredIndex: number | null = null;

  if (falta > 0) {
    let acc = 0;
    for (let i = 0; i < futuras.length; i++) {
      acc += futuras[i].qtyEntrada ?? 0;
      if (acc >= falta) {
        coveredIndex = i;
        coveredDate = futuras[i].fechaEntrada ?? null;
        break;
      }
    }
  }

  return { futuras, totalEntrante, coveredDate, coveredIndex };
}
